import React from 'react';
import { motion } from 'framer-motion';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import CloudOffOutlinedIcon from '@mui/icons-material/CloudOffOutlined';
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined';
import { ChromeButton } from './ChromeButton';
import { SHORT_PITCH, PRODUCT_NAME } from '../constants/site';
const trust = [{
  icon: SavingsOutlinedIcon,
  label: 'Free forever'
}, {
  icon: LockOutlinedIcon,
  label: 'Local-only'
}, {
  icon: CloudOffOutlinedIcon,
  label: 'No tracking'
}, {
  icon: BoltOutlinedIcon,
  label: 'One click'
}];
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-slate-50" data-id="element-78" data-mp="382fhvvzgliim">
      <div className="absolute inset-0 -z-0 bg-[radial-gradient(circle_at_30%_-10%,rgba(29,155,240,0.10),transparent_55%)]" data-id="element-79" data-mp="384jssxvrzhse" />
      <div className="relative mx-auto grid max-w-6xl gap-12 px-4 py-16 sm:px-6 lg:grid-cols-2 lg:items-center lg:py-24" data-id="element-80" data-mp="3o7lprkf2kuls">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-81" data-mp="39b4hj226fw3g">
          <span className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1 text-xs font-medium text-slate-600" data-id="element-82" data-mp="30fy87t3p6vw6">
            <span className="h-1.5 w-1.5 rounded-full bg-[#1d9bf0]" data-id="element-83" data-mp="2qkmsb7gjzimu" />
            Free Chrome extension · Best tool for X Post Screenshot
          </span>
          <h1 className="mt-5 text-4xl font-extrabold leading-tight tracking-tight text-slate-900 sm:text-5xl" data-id="element-84" data-mp="2vgtx2wx7qo37">
            Turn any X post into a clean{' '}
            <span className="text-[#1d9bf0]" data-id="element-85" data-mp="2ljpef72ktar5">shareable image</span>
          </h1>
          <p className="mt-5 max-w-xl text-lg leading-relaxed text-slate-600" data-id="element-86" data-mp="s2b921mmap6q">
            {SHORT_PITCH}
          </p>

          <div className="mt-8 flex flex-col items-start gap-3 sm:flex-row sm:items-center" data-id="element-87" data-mp="najfrjc2u5cw">
            <div className="flex flex-col items-start gap-1.5" data-id="element-88" data-mp="id9tudnwcbtt">
              <ChromeButton data-id="element-89" data-mp="ddf2ya44fm8r" />
              <span className="ml-1 text-xs font-semibold text-[#1d9bf0]" data-id="element-90" data-mp="de6p6ubtw7md">
                Free forever · No account needed
              </span>
            </div>
            <a href="/#how" className="inline-flex items-center justify-center rounded-full px-5 py-3.5 text-base font-semibold text-slate-700 transition-colors hover:text-slate-900" data-id="element-91" data-mp="161t0korasgjs">
              See how it works →
            </a>
          </div>

          <div className="mt-8 flex flex-wrap gap-x-6 gap-y-2" data-id="element-92" data-mp="x3h0lw4jk6eo">
            {trust.map(t => <div key={t.label} className="flex items-center gap-1.5 text-sm font-medium text-slate-500" data-id="element-93" data-mp="3lqm4435bldx1">
                <t.icon sx={{
              fontSize: 18
            }} className="text-[#1d9bf0]" data-id="element-94" data-mp="1xam5wruslszg" />
                {t.label}
              </div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="relative" data-id="element-95" data-mp="2b0fxhhxomrcv">
          <HeroMock data-id="element-96" data-mp="2ozz0jwbmzcib" />
        </motion.div>
      </div>
    </section>;
}
function HeroMock() {
  return <div className="relative mx-auto max-w-md" data-id="element-97" data-mp="2tztw4d6cwq9p">
      {/* browser window */}
      <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-xl" data-id="element-98" data-mp="umprg5n05t0l">
        <div className="flex items-center gap-1.5 border-b border-slate-100 bg-slate-50 px-4 py-3" data-id="element-99" data-mp="zlaro5298cp1">
          <span className="h-3 w-3 rounded-full bg-red-400" data-id="element-100" data-mp="4b461q1btyhv" />
          <span className="h-3 w-3 rounded-full bg-yellow-400" data-id="element-101" data-mp="49jdu72hirn6" />
          <span className="h-3 w-3 rounded-full bg-green-400" data-id="element-102" data-mp="3vgnhcrzf7vqu" />
          <span className="ml-3 truncate rounded-md bg-white px-3 py-1 text-xs text-slate-400" data-id="element-103" data-mp="e9jvzpomb1ps">
            x.com
          </span>
        </div>
        <div className="space-y-3 p-4" data-id="element-104" data-mp="9bs8r8yx43rx">
          {/* selected post */}
          <div className="rounded-xl border-2 border-[#1d9bf0] bg-[#1d9bf0]/5 p-3" data-id="element-105" data-mp="3hpr36668rh3b">
            <div className="flex items-center gap-2" data-id="element-106" data-mp="3crfrrr0asyiz">
              <div className="h-8 w-8 rounded-full bg-slate-200" data-id="element-107" data-mp="3csqstj2czs6e" />
              <div className="space-y-1" data-id="element-108" data-mp="3rgbvjbvbnpds">
                <div className="h-2.5 w-24 rounded bg-slate-300" data-id="element-109" data-mp="3ri6kd19ps1n5" />
                <div className="h-2 w-16 rounded bg-slate-200" data-id="element-110" data-mp="3moc0nxu3zmo2" />
              </div>
              <span className="ml-auto rounded-full bg-[#1d9bf0] px-2 py-0.5 text-[10px] font-semibold text-white" data-id="element-111" data-mp="2yyzm0ig0imed">
                Selected
              </span>
            </div>
            <div className="mt-3 space-y-1.5" data-id="element-112" data-mp="19ixc3z5lzga2">
              <div className="h-2.5 w-full rounded bg-slate-200" data-id="element-113" data-mp="19h2q0hilpi4e" />
              <div className="h-2.5 w-11/12 rounded bg-slate-200" data-id="element-114" data-mp="1e9ngb92atd36" />
              <div className="h-2.5 w-2/3 rounded bg-slate-200" data-id="element-115" data-mp="1eb6umu4e9e2b" />
            </div>
          </div>
          {/* reply */}
          <div className="ml-6 rounded-xl border-2 border-[#1d9bf0] bg-[#1d9bf0]/5 p-3" data-id="element-116" data-mp="14j165udcperv">
            <div className="flex items-center gap-2" data-id="element-117" data-mp="1s9epmwhve5au">
              <div className="h-6 w-6 rounded-full bg-slate-200" data-id="element-118" data-mp="1s9okaxdv10mv" />
              <div className="h-2 w-20 rounded bg-slate-300" data-id="element-119" data-mp="1x8hx0nlbonlz" />
              <span className="ml-auto rounded-full bg-[#1d9bf0] px-2 py-0.5 text-[10px] font-semibold text-white" data-id="element-120" data-mp="1j8gvr715be5z">
                Reply
              </span>
            </div>
            <div className="mt-2 space-y-1.5" data-id="element-121" data-mp="1n88y31zy4o2w">
              <div className="h-2 w-full rounded bg-slate-200" data-id="element-122" data-mp="7ss7mcc5o93l" />
              <div className="h-2 w-3/4 rounded bg-slate-200" data-id="element-123" data-mp="7vo6q3zqp3tm" />
            </div>
          </div>
        </div>
      </div>

      {/* floating result chip */}
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.6
    }} className="absolute -bottom-5 -right-3 flex items-center gap-2 rounded-xl border border-slate-200 bg-white p-2 shadow-lg sm:-right-6" data-id="element-124" data-mp="2eg90ygbilx68">
        <span className="flex items-center gap-1 rounded-lg bg-[#1d9bf0] px-2.5 py-1.5 text-xs font-semibold text-white" data-id="element-125" data-mp="1vqt01rvx42pa">
          <DownloadOutlinedIcon sx={{
          fontSize: 15
        }} data-id="element-126" data-mp="1qrq2stm6j0rv" />{' '}
          Download
        </span>
        <span className="flex items-center gap-1 rounded-lg bg-slate-100 px-2.5 py-1.5 text-xs font-semibold text-slate-700" data-id="element-127" data-mp="1luzdrgsecuub">
          <ContentCopyOutlinedIcon sx={{
          fontSize: 15
        }} data-id="element-128" data-mp="3g6xqvtttuavh" />{' '}
          Copy
        </span>
      </motion.div>

      <span className="sr-only" data-id="element-129" data-mp="3b8mdxa88jk91">
        Illustration of {PRODUCT_NAME} selecting an X post and a reply, ready to
        download or copy as a PNG.
      </span>
    </div>;
}